export default function Snippet (pButton)
{
  this.preInitInsertSnippetButton = () =>
  {
    if (pButton.pGroup.pToolbar.tWindow.BonaDialog === undefined || !pButton.pGroup.pToolbar.tWindow.BonaDialog)
    {
      setTimeout(this.preInitInsertSnippetButton, 100);
      return;
    }

    pButton.pAttribute.Dialog = pButton.pGroup.pToolbar.tWindow.BonaDialog.createInnerWindow(pButton.pAttribute.id + '_Dialog', pButton.pAttribute.parameters);
    BEditor.Dialogs['Snippet'] = { 'id': pButton.pAttribute.id + '_Dialog', 'codeEditor': pButton.pAttribute.codeEditor, 'dialog': pButton.pAttribute.Dialog};
  };
}